module.exports = __webpack_public_path__ + "img/4.76a57877.jpg";